import { gql } from '@apollo/client';

export const FragmentAddress = gql`
  fragment FragmentAddress on CustomerAddress {
    id
    salutation
    firstName
    lastName
    street
    houseNumber
    additionalAddress
    postalCode
    city
    phone
    isDefaultShipping
    isDefaultBilling
    geoCoordinates {
      lat
      lon
    }
  }
`;

export const FragmentShippingAddress = gql`
  fragment FragmentShippingAddress on CustomerAddress {
    salutation
    firstName
    lastName
    street
    houseNumber
    additionalAddress
    postalCode
    city
    phone
    isDefaultShipping
    isDefaultBilling
    geoCoordinates {
      lat
      lon
    }
  }
`;

export const FragmentBillingAddress = gql`
  fragment FragmentBillingAddress on CustomerAddress {
    salutation
    firstName
    lastName
    street
    houseNumber
    additionalAddress
    postalCode
    city
    phone
    geoCoordinates {
      lat
      lon
    }
  }
`;

export const FragmentCustomer = gql`
  fragment FragmentCustomer on Customer {
    id
    firstName
    lastName
    email
    phone
    salutation
    createdAt
    updatedAt
  }
`;
